"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Gradient = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  background-image: linear-gradient(to right, #ff6100, #ffb200, #ffd218);\n  padding: 4px 0;\n"], ["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  background-image: linear-gradient(to right, #ff6100, #ffb200, #ffd218);\n  padding: 4px 0;\n"])));
exports.default = Gradient;
var templateObject_1;
//# sourceMappingURL=Gradient.js.map